import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import MedicalNotice from "@/pages/MedicalNotice";
import Contact from "@/pages/Contact";
import DeleteAccount from "@/pages/DeleteAccount";
import Redirect from "@/components/Redirect";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/politica-privacidad"
                            element={<PrivacyPolicy />}
                        />
                        <Route path="/legal" element={<PrivacyPolicy />} />
                        <Route path="/terminos-de-uso" element={<Terms />} />
                        <Route path="/aviso-medico" element={<MedicalNotice />} />
                        <Route path="/contacto" element={<Contact />} />
                        <Route
                            path="/eliminar-cuenta"
                            element={<DeleteAccount />}
                        />
                        <Route
                            path="/opinion"
                            element={
                                <Redirect to="https://clinical-brain-ai.emergent.host/api/opinion?lang=es" />
                            }
                        />
                        <Route
                            path="/admin/opiniones"
                            element={
                                <Redirect to="https://clinical-brain-ai.emergent.host/api/admin/opiniones" />
                            }
                        />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
